import React from "react";

export default function SQL_Operators() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Operators</h1>
      <p>This is the SQL_Operators component generated from the SQL JSON.</p>
    </div>
  );
}
